import {SortOrder} from '../sort-order';

export class BasicFilters {
  name: string;
  description: string;
  tenantUuids: string[];
  sortField: string;
  sortOrder: SortOrder;
}
